import React from "react";
import { Label } from "../../../components/shared/InputField";
import { Select } from "../../../components/shared/Select";
import { HStack, VStack } from "../../../components/utils";
import { ReportColumn } from "../utils/reportColumns";

type SortOrder = "asc" | "desc";

const sortOrderOptions: { value: SortOrder; label: string }[] = [
  { value: "asc", label: "Ascending" },
  { value: "desc", label: "Descending" },
];

type Props = {
  columns: ReportColumn[];
  sortBy: string;
  sortOrder: SortOrder;
  onSortByChange: (value: string) => void;
  onSortOrderChange: (value: SortOrder) => void;
};

const SortSection = ({
  columns,
  sortBy,
  sortOrder,
  onSortByChange,
  onSortOrderChange,
}: Props) => (
  <VStack className="w-full gap-3 mt-4 pt-4 border-t border-gray-100">
    <Label className="text-sm font-medium">Sort</Label>
    <HStack className="gap-8">
      <div className="flex-1">
        <Label className="text-sm font-normal">Sort By</Label>
        <Select
          options={columns}
          value={sortBy}
          placeholder="--Default order--"
          valueGetter={(column) => column.key}
          textGetter={(column) => column.label}
          onChange={(e) => onSortByChange(e.target.value)}
        />
      </div>
      <div className="flex-1">
        <Label className="text-sm font-normal">Order</Label>
        <Select
          options={sortOrderOptions}
          value={sortOrder}
          disabled={!sortBy}
          valueGetter={(option) => option.value}
          textGetter={(option) => option.label}
          onChange={(e) => onSortOrderChange(e.target.value as SortOrder)}
        />
      </div>
    </HStack>
  </VStack>
);

export default SortSection;
